import React from "react";


const  ResetPassword = () => {
  
  return (
    <>
 <h1> Reset Password</h1>
</>
  );
}

export default ResetPassword;
